import React from "react";
import { withTranslation } from "react-i18next";

import { Modal, ModalBody } from "reactstrap";
import crossIcon from "assets/images/cross.svg";
import staffStyles from "pages/Staff/staff.module.scss";

function AccountPreferencesInfoModal({ t, isOpen, onClose }) {
  return (
    <Modal
      isOpen={isOpen}
      toggle={() => onClose(false)}
      className="modal-md modal-dialog-centered modal-lg"
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={() => onClose(false)}>
        <img src={crossIcon} alt="close" />
      </span>

      <ModalBody>
        <p className="title">{t("helpGuide")}</p>
        <div className={staffStyles.modal_container}>
          <p>{t("accountPreferences.accountSettingSubHeading")}</p>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default withTranslation()(AccountPreferencesInfoModal);
